/* eslint-disable react/jsx-props-no-spreading */
import { JsonEditor, JsonEditorProps } from 'json-edit-react';
import { Button, UnstyledButton } from '@mantine/core';
// icons
import { Plus, Edit, Copy } from 'lucide-react';
// assets
import styles from '@/components/JSONEdit/JSONEdit.module.css';

const icons = {
    cancel: (
        <UnstyledButton className="text-xs text-gray-6 block">
            Cancel
        </UnstyledButton>
    ),
    ok: (
        <Button className="px-3 h-6" size="xs">
            Save
        </Button>
    ),
    add: <Plus />,
    edit: <Edit />,
    copy: <Copy />
};

const JSONEdit = (props: JsonEditorProps) => {
    return <JsonEditor {...props} className={styles.editor} icons={icons} />;
};

export default JSONEdit;
